import { FileDown, FileText, SquareArrowOutUpRight } from 'lucide-react';

import type { GetAllReservations } from '@virtual-care/client';
import { formatFileSize } from '@virtual-care/isomorphic';
import { ViewFile } from '@virtual-care/media-web';

type ReservationFile = GetAllReservations['records'][number]['files'][number];

export function AttachedFiles({
  reservation,
}: {
  reservation: GetAllReservations['records'][number];
}) {
  return (
    <div className="bg-muted/50 rounded-lg p-4">
      <h3 className="mb-3 flex items-center gap-2 font-semibold">
        <FileText className="h-4 w-4" />
        Attached Files ({reservation.files.length})
      </h3>
      <div className="space-y-2">
        {reservation.files.map((file) => (
          <FileItem key={file.id} file={file} />
        ))}
      </div>
    </div>
  );
}

function FileItem({ file }: { file: ReservationFile }) {
  return (
    <div className="bg-background flex items-center justify-between rounded border p-2">
      <div className="flex items-center gap-2">
        <FileDown className="text-muted-foreground h-4 w-4" />
        <span className="text-sm font-medium">{file.file.name}</span>
        <span className="text-muted-foreground text-xs">
          ({file.file.contentType})
        </span>
        {file.file.size > 0 && (
          <span className="text-muted-foreground text-xs">
            {formatFileSize(file.file.size)}
          </span>
        )}
      </div>
      <ViewFile
        fileId={file.fileId}
        variant="outline"
        size="sm"
        icon={<SquareArrowOutUpRight className="h-4 w-4" />}
      >
        View
      </ViewFile>
    </div>
  );
}
